import './CourseGroupList.scss';
import * as React from 'react';
import classNames from 'classnames';
import { DotLoader } from '../Loaders';
import { ITitleItem } from 'src/types/Courses';

type ListGroup = {
  id: string | number;
  title: string;
  groups: ITitleItem[];
};

type CoursesGroupListProps = {
  lists: ListGroup[];
  isLoading?: boolean;
  onItemClick: (id: string | number, groupId: string | number) => void;
};

const CourseGroupList = ({
  lists,
  isLoading,
  onItemClick,
}: CoursesGroupListProps) => {
  if (lists.length === 0 && isLoading) {
    return (
      <div className="CourseGroupList">
        <DotLoader className="CourseGroupListLoader" />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'CourseGroupList',
        isLoading === true && 'is-loading'
      )}
    >
      {isLoading === true && (
        <DotLoader className="CourseGroupListLoader" />
      )}
      {lists.map((list) => (
        <div key={list.title} className="CourseGroupListGroup">
          <h4 className="CourseGroupListTitle">{list.title}</h4>
          {list.groups.map((group) => (
            <div
              key={group.title}
              className="CourseGroupListItem"
              onClick={() => onItemClick(group.id, list.id)}
            >
              {group.title} ({group.numberOfCourses})
            </div>
          ))}
        </div>
      ))}
    </div>
  )
};

export default CourseGroupList;



// WEBPACK FOOTER //
// ./src/components/CourseGroupList/index.tsx